module.exports = __webpack_public_path__ + "img/Dual tune.e921d5c1.png";